// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question-mark-o.icon{color:#000;position:absolute;margin-left:2px;margin-top:2px;width:15px;height:15px;border:1px solid currentColor;border-radius:8px}.question-mark-o.icon:before{content:\"?\";position:absolute;top:-2px;left:3px;width:17px;height:1px}", ""]);
// Exports
module.exports = exports;
